var $ = require('jquery')
  , Video = require('widgets/Video')

$(function() {
  var shortVideo = $('.short-video')

  shortVideo.on('click', '.pic-box', function(e) {
    var videoUrl = shortVideo.data('video-url')
    var video = new Video({
      videoUrl: videoUrl
    , width: '700'
    , height: '400'
    })

    shortVideo.html(video.toHTML())
  })
})
